/* eslint-disable no-param-reassign */
/* global HTMLButtonElement */

// eslint-disable-next-line no-unused-vars
function CookiePage() {
  function getSubmitButton() {
    return document.querySelector(`button[data-cookie-action="saveChoices"]`);
  }

  function setCheckboxesChecked(checked) {
    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"]:not([required])`,
    );
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  const cookieDialog = document.querySelector('[data-show-dialog="cookie"]');
  if (cookieDialog) {
    cookieDialog.showModal();
  }

  document.addEventListener("click", (e) => {
    const { target } = e;

    if (!(target instanceof HTMLButtonElement)) {
      return;
    }

    if (target.dataset.cookieAction === "acceptNecessary") {
      setCheckboxesChecked(false);
      const submit = getSubmitButton();
      if (submit) {
        submit.click();
      }
    }

    if (target.dataset.cookieAction === "acceptAll") {
      setCheckboxesChecked(true);
      const submit = getSubmitButton();
      if (submit) {
        submit.click();
      }
    }
  });
}

export { CookiePage };
